import { createI18n } from "vue-i18n";

const i18n = createI18n({
    legacy: false,
    locale: "de",
    fallbackLocale: "de",
    globalInjection: true,
    messages: {
        de: require("@/core/locales/de.json"),
        en: require("@/core/locales/en.json"),
    },
});

export default i18n;
